import { useQuery } from '@tanstack/react-query';
import { GET_ACCESS_TOKEN } from '@/helpers/query-keys';
import { exchangeAccessToken } from '@/services/auth.service';

export const useExchangeAccessToken = () => {
  return useQuery({
    queryKey: [GET_ACCESS_TOKEN],
    queryFn: async () => await exchangeAccessToken(),
    retry: false,
  });
};
